import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function TifControlCenter() {
  const nav = useNavigate();
  const [tenants, setTenants] = useState(null);
  const [flags, setFlags] = useState([]);
  const [audit, setAudit] = useState([]);

  const authHeader = () => ({ headers: { Authorization: "Bearer " + (localStorage.getItem("aiude_admin_token") || "") } });

  useEffect(() => {
    const tok = localStorage.getItem("aiude_admin_token");
    if (!tok) { nav("/admin/login"); return; }
    Promise.all([
      axios.get(API + "/admin/control-center/tenants", authHeader()),
      axios.get(API + "/admin/control-center/feature-flags", authHeader()),
      axios.get(API + "/admin/control-center/audit", authHeader()),
    ]).then(([t, f, a]) => { setTenants(t.data); setFlags(f.data.flags || []); setAudit(a.data.events || []); })
    .catch((e) => { if (e?.response?.status === 401) { localStorage.removeItem("aiude_admin_token"); nav("/admin/login"); } else toast.error("Failed to load TIF console"); });
  }, [nav]);

  const setFlag = async (key, enabled) => {
    try {
      await axios.put(API + "/admin/control-center/feature-flags/" + key, { enabled }, authHeader());
      setFlags((prev) => {
        const found = prev.find((f) => f.key === key);
        return found ? prev.map((f) => f.key === key ? { ...f, enabled } : f) : [...prev, { key, enabled }];
      });
    } catch (e) { toast.error("Failed to update flag"); }
  };

  return (
    <div className="space-y-6 py-6" data-testid="tif-control-center-page">
      <div>
        <div className="font-tech text-xs text-[#C9A961]">TIF PLATFORM ADMIN</div>
        <h1 className="text-2xl sm:text-3xl font-bold text-white">Control Center</h1>
      </div>

      {tenants && (
        <div className="panel-elev p-5">
          <h2 className="text-sm font-tech text-slate-400 mb-3">TENANTS · {tenants.users_count} users</h2>
          <div className="space-y-1 max-h-72 overflow-y-auto">
            {tenants.workspaces.map((w) => (
              <div key={w.id} className="flex justify-between text-xs font-mono border-b border-slate-800/60 py-1">
                <span className="text-slate-300">{w.name}</span>
                <span className="text-slate-500">{w.id.slice(0, 12)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="panel-elev p-5" data-testid="tif-feature-flags">
        <h2 className="text-sm font-tech text-slate-400 mb-3">FEATURE FLAGS</h2>
        {[["control_center_v1", "Control Center V1"], ["invitations", "Workspace member invitations"]].map(([key, label]) => {
          const cur = flags.find((f) => f.key === key)?.enabled ?? false;
          return (
            <div key={key} className="flex justify-between items-center border-b border-slate-800 py-2 text-sm">
              <div><div className="text-white">{label}</div><div className="text-[10px] font-mono text-slate-500">{key}</div></div>
              <button onClick={() => setFlag(key, !cur)} className={`text-[10px] font-mono px-2 py-1 rounded border ${cur ? "border-[#00D2FF]/40 text-[#00D2FF]" : "border-slate-600 text-slate-400"}`}>{cur ? "ON" : "OFF"}</button>
            </div>
          );
        })}
      </div>

      <div className="panel-elev p-5">
        <h2 className="text-sm font-tech text-slate-400 mb-3">GLOBAL AUDIT</h2>
        <div className="space-y-1 max-h-80 overflow-y-auto">
          {audit.map((a) => (
            <div key={a.id} className="flex justify-between text-[11px] font-mono border-b border-slate-800/60 py-1">
              <span className="text-slate-300">{a.action}</span>
              <span className="text-slate-500">{a.actor_role} · {new Date(a.at).toLocaleString()}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
